import React, { useState } from "react";

import { Popup } from "@/components/popups/Popup";
import { FORM_FIELDS } from "./constants";
import { onClosePreferencesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { Checkbox } from "@/components/inputs/Checkbox";
import "./PreferencesPopup.scss";
import { useUserSettingsHandlers } from "@/common/hooks/useUserSettingsHandlers";

export const PreferencesPopup = () => {
  const { updateUserProfile } = useUserSettingsHandlers();

  const [isSendingData, setSendingData] = useState(false);
  const [prefOptions, setPrefOptions] = useState(FORM_FIELDS);

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const targetName = event.target.name;
    const copyOptions = [...prefOptions];

    for (const filed of copyOptions) {
      if (filed.name === targetName) {
        filed.isChecked = !filed.isChecked;
      }
    }

    setPrefOptions([...copyOptions]);
  };

  const canSend = (): boolean => {
    const selected = prefOptions.filter((x) => x.isChecked);
    return !isSendingData && selected.length > 0; // isSendingData
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setSendingData(true);

    const filterCheckedPrefs = prefOptions.filter(({ isChecked }) => isChecked);
    const prefValues = filterCheckedPrefs.length ?
      filterCheckedPrefs.map(({ value }) => value) : [];

    const dataToSend = [
      {
        path: "/preferences",
        value: prefValues
      }
    ];

    await updateUserProfile(dataToSend);
    onClosePreferencesPopup();
    setSendingData(false);
  };

  const btnProps = {
    variant: 1,
    title: isSendingData ? "Sending..." : "Save",
    onClick: handleSubmit,
    disabled: !canSend()
  };

  return (
    <Popup
      title="Define Your Preferences"
      isOpen={true}
      popupClass="PopupPreferences"
      btnProps={btnProps}
    >
      <div className="PopupPreferences-Cnt">
        <p className="PopupPreferences-Description">Customize your RedGIFs experience by selecting what you'd like to see:</p>
        <div className="PopupPreferences-Form">
          {prefOptions.map((filed, index) => (
            <div className="PrefOption" key={index}>
              <Checkbox label={filed.name} onChange={handleCheckBoxChange} checked={filed.isChecked} name={filed.name} />
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};
